import { Grid } from "@mui/material";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getFormulariosPrevencionEstablecimiento } from "../../../../redux/actions/establecimiento";
import CardContainer from "../../../commons/cards/CardContainer";
import { tableStyles } from "../../../commons/table/tableConfig";
import { StyledEstablecimientos } from "../../../styled/Prevencion";
import FormulariosPrevencionCard from "./cards/FormulariosPrevencionCard";
import AyudaLabelEstablecimientoDetalle from "./label/AyudaLabelEstablecimientoDetalle";
import HeaderLabelEstablecimientoDetalle from "./label/HeaderLabelEstablecimientoDetalle";


const EstadoEstablecimientoDetalle = ({
  establecimiento,
  formularioSeleccionadoAdjuntar,
  setIsModalAdjuntarFormOpen,
  handleVisualizar,
  handleEditarResolucion81,
}) => {
  const dispatch = useDispatch();
  const formulariosPrevencion = useSelector(
    (state) => state.establecimiento.formulariosPrevencion
  );

  useEffect(() => {
    dispatch(
      getFormulariosPrevencionEstablecimiento(
        establecimiento?.idDependenciaEmpleador
      )
    );
  }, [establecimiento, dispatch]);

  return (
    <>
      <HeaderLabelEstablecimientoDetalle establecimiento={establecimiento} />
      <AyudaLabelEstablecimientoDetalle />
      <CardContainer
        title="Formularios de Prevención"
        loading={formulariosPrevencion.loading}
        componenteSubtitulo={
          <StyledEstablecimientos.StickyCard
            elevation={2}
            sx={tableStyles.headerStyle}
          >
            <Grid container spacing={2}>
              <Grid item xs={2}>
                Fecha Presentación
              </Grid>
              <Grid item xs={4}>
                Formulario
              </Grid>
              <Grid
                item
                xs={2}
                style={{ display: "flex", justifyContent: "center" }}
              >
                Cargado en el Portal
              </Grid>
              <Grid
                item
                xs={2}
                style={{ display: "flex", justifyContent: "center" }}
              >
                Estado
              </Grid>
              <Grid
                item
                xs={2}
                style={{ display: "flex", justifyContent: "center" }}
              >
                Operaciones
              </Grid>
            </Grid>
          </StyledEstablecimientos.StickyCard>
        }
        componente={
          <FormulariosPrevencionCard
            data={formulariosPrevencion.data}
            formularioSeleccionadoAdjuntar={formularioSeleccionadoAdjuntar}
            setIsModalAdjuntarFormOpen={setIsModalAdjuntarFormOpen}
            handleVisualizar={handleVisualizar}
            handleEditarResolucion81={handleEditarResolucion81}
          />
        }
      />
    </>
  );
};

export default EstadoEstablecimientoDetalle;
